export default __webpack_public_path__ + "static/media/4insta.680a6931.jpg";